import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import EditQuestionnaire from '../components/dashboard/EditQuestionnaire';
import EditProfileForm from '../components/dashboard/EditProfileForm';
import ChatBot from '../components/dashboard/Chatbot';
import PaymentSection from '../components/PaymentSection';
import GoogleCalendar from '../components/GoogleCalendar';
import '../components/dashboard/Dashboard.css';
import PremiumUniversityAdvisor from '../components/PremiumUniversityAdvisor';

import Questionnaire from '../components/dashboard/Questionnaire';

import './Recommendations.css';

const universities = [
  {
    name: "University of Texas at Arlington",
    city: "Arlington",
    state: "Texas",
    acceptanceRate: "81%",
    annualTuitionUSD: 29582,
    avgLivingCostUSD: 16000,
    websiteURL: "https://www.uta.edu/admissions/international-undergraduate",
    minGPA: 2.75,
    minTOEFL: 79,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Colorado Boulder",
    city: "Boulder",
    state: "Colorado",
    acceptanceRate: "81%",
    annualTuitionUSD: 43622,
    avgLivingCostUSD: 15972,
    websiteURL: "https://www.colorado.edu/admissions/international",
    minGPA: 3.0,
    minTOEFL: 72,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Cincinnati",
    city: "Cincinnati",
    state: "Ohio",
    acceptanceRate: "69%",
    annualTuitionUSD: 20000,
    avgLivingCostUSD: 16000,
    websiteURL: "https://admissions.uc.edu/information/international/requirements.html",
    minGPA: 3.0,
    minTOEFL: 80,
    minIELTS: 6.5,
    minDuolingo: 110,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Indiana University Bloomington",
    city: "Bloomington",
    state: "Indiana",
    acceptanceRate: "82%",
    annualTuitionUSD: 56000,
    avgLivingCostUSD: 18000,
    websiteURL: "https://ois.iu.edu/admissions/index.html",
    minGPA: 3.3,
    minTOEFL: 80,
    minIELTS: 6.5,
    minDuolingo: 0,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Pace University",
    city: "New York",
    state: "New York",
    acceptanceRate: "83%",
    annualTuitionUSD: 53290,
    avgLivingCostUSD: 30000,
    websiteURL: "https://www.pace.edu/admission-and-aid/international-admission",
    minGPA: 3.0,
    minTOEFL: 78,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Kent State University",
    city: "Kent",
    state: "Ohio",
    acceptanceRate: "88%",
    annualTuitionUSD: 23690,
    avgLivingCostUSD: 19384,
    websiteURL: "https://www.kent.edu/admissions/international-first-year-student-requirements",
    minGPA: 2.5,
    minTOEFL: 71,
    minIELTS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Maine",
    city: "Orono",
    state: "Maine",
    acceptanceRate: "96%",
    annualTuitionUSD: 30300,
    avgLivingCostUSD: 16000,
    websiteURL: "https://umaine.edu/international",
    minGPA: 2.5,
    minTOEFL: 79,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Toledo",
    city: "Toledo",
    state: "Ohio",
    acceptanceRate: "95%",
    annualTuitionUSD: 25000,
    avgLivingCostUSD: 14000,
    websiteURL: "https://www.utoledo.edu/admission/international",
    minGPA: 2.5,
    minTOEFL: 80,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Wyoming",
    city: "Laramie",
    state: "Wyoming",
    acceptanceRate: "97%",
    annualTuitionUSD: 20760,
    avgLivingCostUSD: 14000,
    websiteURL: "https://international.uwyo.edu/admissions",
    minGPA: 2.5,
    minTOEFL: 71,
    minIELTS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of New Mexico",
    city: "Albuquerque",
    state: "New Mexico",
    acceptanceRate: "96%",
    annualTuitionUSD: 13346,
    avgLivingCostUSD: 18000,
    websiteURL: "https://international.unm.edu",
    minGPA: 3.0,
    minTOEFL: 68,
    minIELTS: 6.0,
    minDuolingo: 95,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Utah State University",
    city: "Logan",
    state: "Utah",
    acceptanceRate: "94%",
    annualTuitionUSD: 24080,
    avgLivingCostUSD: 15000,
    websiteURL: "https://www.usu.edu/admissions/international",
    minGPA: 2.7,
    minTOEFL: 71,
    minIELTS: 6.0,
    minDuolingo: 0,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Cameron University",
    city: "Lawton",
    state: "Oklahoma",
    acceptanceRate: "100%",
    annualTuitionUSD: 16515,
    avgLivingCostUSD: 19262,
    websiteURL: "https://www.cameron.edu/admissions/international-student..." ,
    minGPA: 2.7,
    minTOEFL: 61,
    minIELTS: 5.5,
    minDuolingo: 100,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Texas at El Paso",
    city: "El Paso",
    state: "Texas",
    acceptanceRate: "100%",
    annualTuitionUSD: 21164,
    avgLivingCostUSD: 15000,
    websiteURL: "https://www.utep.edu/student-affairs/admissions/admission-info/international.html",
    minGPA: 2.0,
    minTOEFL: 61,
    minIELTS: 0,
    minDuolingo: 0,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Weber State University",
    city: "Ogden",
    state: "Utah",
    acceptanceRate: "100%",
    annualTuitionUSD: 15000,
    avgLivingCostUSD: 14000,
    websiteURL: "https://www.weber.edu/issc/international-admissions.html",
    minGPA: 2.5,
    minTOEFL: 68,
    minIELTS: 6.0,
    minDuolingo: 0,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Missouri Western State University",
    city: "St. Joseph",
    state: "Missouri",
    acceptanceRate: "90%",
    annualTuitionUSD: 17568,
    avgLivingCostUSD: 16000,
    websiteURL: "https://www.missouriwestern.edu/global/cost-and-scholarships/",
    minGPA: 2.0,
    minTOEFL: 70,
    minIELTS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Montana State University–Billings",
    city: "Billings",
    state: "Montana",
    acceptanceRate: "85%",
    annualTuitionUSD: 14000,
    avgLivingCostUSD: 15000,
    websiteURL: "https://www.msubillings.edu/internationalstudies/admissions",
    minGPA: 3.0,
    minTOEFL: 68,
    minIELTS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Adams State University",
    city: "Alamosa",
    state: "Colorado",
    acceptanceRate: "99%",
    annualTuitionUSD: 21847,
    avgLivingCostUSD: 15000,
    websiteURL: "https://www.adams.edu/admissions/international/requirements/",
    minGPA: 2.5,
    minTOEFL: 71,
    minIELTS: 6.0,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Guam",
    city: "Mangilao",
    state: "Guam",
    acceptanceRate: "100%",
    annualTuitionUSD: 10605,
    avgLivingCostUSD: 12000,
    websiteURL: "https://www.uog.edu/admissions/international-students.php",
    minGPA: 2.5,
    minTOEFL: 50,
    minIELTS: 5.0,
    minDuolingo: 90,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Maine–Presque Isle",
    city: "Presque Isle",
    state: "Maine",
    acceptanceRate: "90%",
    annualTuitionUSD: 15000,
    avgLivingCostUSD: 16000,
    websiteURL: "https://www.umpi.edu/international-student-services/",
    minGPA: 2.0,
    minTOEFL: 71,
    minIELTS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "University of Providence",
    city: "Great Falls",
    state: "Montana",
    acceptanceRate: "85%",
    annualTuitionUSD: 14000,
    avgLivingCostUSD: 14000,
    websiteURL: "https://www.providence.edu/admissions/international",
    minGPA: 3.0,
    minTOEFL: 79,
    minIELTS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Grace Christian University",
    city: "Wyoming",
    state: "Michigan",
    acceptanceRate: "90%",
    annualTuitionUSD: 12000,
    avgLivingCostUSD: 13000,
    websiteURL: "https://www.gcc.edu/admissions/international",
    minGPA: 2.5,
    minTOEFL: 71,
    minIELTS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Albizu University",
    city: "Miami",
    state: "Florida",
    acceptanceRate: "79%",
    annualTuitionUSD: 15000,
    avgLivingCostUSD: 18000,
    websiteURL: "https://www.albizu.edu/admissions",
    minGPA: 2.5,
    minTOEFL: 0,
    minIELTS: 0,
    minDuolingo: 0,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Long Island University",
    city: "New York",
    state: "New York",
    acceptanceRate: "93%",
    annualTuitionUSD: 30000,
    avgLivingCostUSD: 20000,
    websiteURL: "https://liu.edu/admissions/international",
    minGPA: 3.0,
    minTOEFL: 75,
    minIELTS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "New York Institute of Technology",
    city: "Old Westbury",
    state: "New York",
    acceptanceRate: "60%",
    annualTuitionUSD: 30000,
    avgLivingCostUSD: 20000,
    websiteURL: "https://www.nyit.edu/admissions/international",
    minGPA: 3.6,
    minTOEFL: 79,
    minIELTS: 6.0,
    minDuolingo: 105,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: true,
    offersLaw: true,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Webb Institute",
    city: "Glen Cove",
    state: "New York",
    acceptanceRate: "55%",
    annualTuitionUSD: 50000,
    avgLivingCostUSD: 20000,
    websiteURL: "https://www.webb.edu",
    minGPA: 0,
    minTOEFL: 0,
    minIELTS: 0,
    minDuolingo: 0,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: false,
    offersCommerce: false
  },
  {
    name: "Southern Virginia University",
    city: "Buena Vista",
    state: "Virginia",
    acceptanceRate: "98%",
    annualTuitionUSD: 20780,
    avgLivingCostUSD: 10258,
    websiteURL: "https://www.svu.edu/admissions/",
    minGPA: 2.5,
    minTOEFL: 0,
    minIELTLS: 0,
    minDuolingo: 0,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Alliant International University",
    city: "San Diego",
    state: "California",
    acceptanceRate: "0%",
    annualTuitionUSD: 26726,
    avgLivingCostUSD: 18000,
    websiteURL: "https://www.alliant.edu/admissions/international",
    minGPA: 2.0,
    minTOEFL: 80,
    minIELTLS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Middle Georgia State University",
    city: "Macon",
    state: "Georgia",
    acceptanceRate: "80%",
    annualTuitionUSD: 19100,
    avgLivingCostUSD: 15000,
    websiteURL: "https://www.mga.edu/admissions/international/",
    minGPA: 2.5,
    minTOEFL: 71,
    minIELLS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: true,
    offersEngineering: true,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Naropa University",
    city: "Boulder",
    state: "Colorado",
    acceptanceRate: "90%",
    annualTuitionUSD: 13600,
    avgLivingCostUSD: 15000,
    websiteURL: "https://www.naropa.edu/admissions/international/requirements.php",
    minGPA: 2.5,
    minTOEFL: 79,
    minIELLS: 6.5,
    minDuolingo: 105,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: true,
    offersCommerce: true
  },
  {
    name: "Southwest Baptist University",
    city: "Cape Girardeau",
    state: "Missouri",
    acceptanceRate: "84%",
    annualTuitionUSD: 21200,
    avgLivingCostUSD: 14000,
    websiteURL: "https://www.sbuniv.edu/admissions/international/",
    minGPA: 2.0,
    minTOEFL: 71,
    minIELLS: 6.0,
    minDuolingo: 100,
    offersScience: true,
    offersCS: false,
    offersEngineering: false,
    offersArchitecture: false,
    offersLaw: false,
    offersArt: true,
    offersCommerce: true
  }
];

const Dashboard = ({ user, setUser, handleLogout }) => {
    const navigate = useNavigate();
    const [showQuestionnaire, setShowQuestionnaire] = useState(false);

    const [hasAnsweredQuestionnaire, setHasAnsweredQuestionnaire] = useState(false);
    const [selectedQuestionnaire, setSelectedQuestionnaire] = useState(null);
    const [showEditQuestionnaire, setShowEditQuestionnaire] = useState(false);
    const [hasCompletedProfile, setHasCompletedProfile] = useState(true);
    const [showEditProfileForm, setShowEditProfileForm] = useState(false);
    const [recommendations, setRecommendations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasPayment, setHasPayment] = useState(false);
    const [appliedUniversities, setAppliedUniversities] = useState(new Set());
    const [attemptedSearch, setAttemptedSearch] = useState(false);

    
    const apiUrlRootPath = process.env.REACT_APP_API_URL;


    const [fields, setFields] = useState({
    Science: false,
    CS: false,
    Engineering: false,
    Architecture: false,
    Law: false,
    Art: false,
    Commerce: false
  });
  const toggleField = key => setFields(f => ({ ...f, [key]: !f[key] }));

  const [maxTuition, setMaxTuition]     = useState('');
  const [minGPA,     setMinGPA]         = useState('');
  const [minTOEFL,   setMinTOEFL]       = useState('');
  const [minIELTS,   setMinIELTS]       = useState('');
  const [minDuolingo,setMinDuolingo]    = useState('');

  // loading + results toggle
  const [recLoading, setRecLoading]     = useState(false);
  const [showResults, setShowResults]   = useState(false);

  // budget modal
  const [budgetUni, setBudgetUni]            = useState(null);
  const [showBudgetModal, setShowBudgetModal] = useState(false);
  const openBudget = uni => {
    setBudgetUni(uni);
    setShowBudgetModal(true);
  };

  // ── AI-style filter + scoring ──
  const filteredRecs = useMemo(() => {
    // default to questionnaire field if no pill is active
    const activeFields = Object.keys(fields).filter(k=>fields[k]);
    if (!activeFields.length && selectedQuestionnaire?.FieldOfStudy) {
      activeFields.push(selectedQuestionnaire.FieldOfStudy.name);
    }

    // determine budget: user input or questionnaire fee
    const budget = maxTuition
      ? +maxTuition
      : (selectedQuestionnaire?.Fee?.amount
         ? +selectedQuestionnaire.Fee.amount
         : null
        );

    // filter
    let recs = universities.filter(u => {
  // Field of study filter
  if (activeFields.length && !activeFields.some(f => u[`offers${f}`])) return false;

  // Convert inputs safely
  const budgetVal     = parseFloat(maxTuition);
  const gpaVal        = parseFloat(minGPA);
  const toeflVal      = parseFloat(minTOEFL);
  const ieltsVal      = parseFloat(minIELTS);
  const duolingoVal   = parseFloat(minDuolingo);

  // Budget filter
  if (!isNaN(budgetVal) && u.annualTuitionUSD > budgetVal) return false;

  // GPA filter
  if (!isNaN(gpaVal) && u.minGPA > gpaVal) return false;

  // Language score filter — only apply if user's value is present
  if (!isNaN(toeflVal) && u.minTOEFL > toeflVal) return false;
  if (!isNaN(ieltsVal) && u.minIELTS > ieltsVal) return false;
  if (!isNaN(duolingoVal) && u.minDuolingo > duolingoVal) return false;

  return true;
});


    // score + sort
    return recs
      .map(u => {
        let score = parseFloat(u.acceptanceRate);
        if (budget) {
          let diff = Math.abs(u.annualTuitionUSD - budget)/budget;
          score += (1 - diff) * 10;
        }
        // boost if matches user's questionnaire field
        if (selectedQuestionnaire?.FieldOfStudy
            && u[`offers${selectedQuestionnaire.FieldOfStudy.name}`]) {
          score += 5;
        }
        // boost if language meets requirement
        const test = selectedQuestionnaire?.languageTest;
        const userScore = selectedQuestionnaire?.languageScore || 0;
        if (test && userScore >= u[`min${test}`]) score += 3;

        return { uni: u, score };
      })
      .sort((a,b) => b.score - a.score)
      .map(x => x.uni);
  }, [
    fields, maxTuition, minGPA, minTOEFL, minIELTS, minDuolingo,
    selectedQuestionnaire
  ]);

  // ── “Search” button ──
  const handleSearchRecs = () => {
  setAttemptedSearch(true);

  const valid =
    maxTuition !== '' &&
    minGPA !== '' &&
    (+minGPA >= 0 && +minGPA <= 4) &&
    (minTOEFL !== '' || minIELTS !== '' || minDuolingo !== '');

  if (!valid) return;

  setShowResults(false);  
  setRecLoading(true);

  setTimeout(() => {
    setRecLoading(false);
    setShowResults(true);
  }, 800);
};




    const handleEditClick = () => {
        setShowEditQuestionnaire(true);
    };

    const handleQuestionnaireUpdate = (updatedData) => {
        checkQuestionnaireStatus();
    };

    const handleApply = async (universityId) => {
        if (!hasPayment) {
            alert("Please complete payment to apply");
            return;
        }
        
        try {
            const response = await axios.post(`${apiUrlRootPath}/questionnaires/apply-university`, {
                userId: user.id,
                universityId: universityId
            });
            
            if (response.data.success) {
                setAppliedUniversities(prev => new Set([...prev, universityId]));
                alert('Application submitted successfully!');
            }
        } catch (error) {
            console.error('You have already applied to this University:', error);
            alert('You have already applied to this University.');
        }
    };

    useEffect(() => {
        if (hasPayment) {
            Swal.fire({
                title: 'Full Access Unlocked! 🎉',
                text: 'You can now apply to any university of your choice',
                icon: 'success',
                confirmButtonText: 'Let\'s Start!',
                confirmButtonColor: '#34a853',
                background: '#1a1f2e',
                color: '#ffffff'
            });
        }
    }, [hasPayment]);

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('user'));

        if (storedUser && storedUser.id) {
            checkQuestionnaireStatus(storedUser.id);
            fetchRecommendations(storedUser.id);
        }
    }, [user]);

    const fetchRecommendations = async (userId) => {
        try {
            const response = await axios.get(`${apiUrlRootPath}/questionnaires/recommendations/${userId}`);
            setRecommendations(response.data.recommendations);
            setHasPayment(response.data.hasPayment);
        } catch (error) {
            console.error('Error fetching recommendations:', error);
        } finally {
            setLoading(false);
        }
    };

    const checkQuestionnaireStatus = async (userId) => {
        try {
            const response = await axios.get(`${apiUrlRootPath}/questionnaires/status/${userId}`);
            const profileResponse = await axios.get(`${apiUrlRootPath}/questionnaires/profile-status/${userId}`);
            
            setSelectedQuestionnaire(response.data.questionnaire);
            setHasCompletedProfile(profileResponse.data.hasCompletedProfile);
    
            setHasAnsweredQuestionnaire(response.data.hasAnswered);
            
    // Prevent showing the questionnaire again if already answered
            if (!response.data.hasAnswered && !localStorage.getItem('questionnaireShown')) {
      setShowQuestionnaire(true); // Show questionnaire only if not already answered
            }
        } catch (error) {
            console.log('Error checking questionnaire status:', error);
        }
    };
    const handleQuestionnaireSubmit = (data) => {
  // Save to localStorage that the questionnaire has been completed
  localStorage.setItem('questionnaireShown', 'true');  // Mark questionnaire as completed

  // Set the state to close the questionnaire popup
        setShowQuestionnaire(false);

  // You can also update the database if needed, and refresh the questionnaire status
  checkQuestionnaireStatus(user.id);  // Make sure the questionnaire status is checked again
    };
    const handleCloseQuestionnaire = () => {
  setShowQuestionnaire(false);  // Close the questionnaire modal
  localStorage.setItem('questionnaireShown', 'true');  // Prevent showing it again
    };


    // JavaScript for Tab Interactivity
    useEffect(() => {
        const tabs = document.querySelectorAll('.sidebar ul li');
        const contents = document.querySelectorAll('.tab-content');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                // Remove active class from all tabs and add to clicked tab
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                // Hide all content and show the corresponding tab content
                const target = tab.getAttribute('data-tab');
                contents.forEach(content => {
                    content.classList.remove('active');
                    if (content.id === target) {
                        content.classList.add('active');
                    }
                });
            });
        });
    }, []);

    return (
        <div className="dashboard-container">
            {/* Sidebar */}
            <div className="sidebar">
                <div className="sidebar-header">
                    <h3>🎓 Dashboard</h3>
                </div>
                <ul>
                    <li className="active" data-tab="make-payment">
                        <span>
                            <i className="fa fa-credit-card"></i>
                            Make Payment
                        </span>
                    </li>
                    <li data-tab="schedule-appointment">
                        <span>
                            <i className="fa fa-calendar"></i>
                            Schedule Appointment
                        </span>
                    </li>
                    {/* <li data-tab="dashboard">
                        <span>
                            <i className="fa fa-clipboard"></i>
                            Questionnaire
                        </span>
                    </li> */}
                    <li data-tab="recommendations">
  <span>
    <i className="fa fa-university"></i>
    University Recommendations
  </span>
</li>

                    <li data-tab="profile">
                        <span>
                            <i className="fa fa-user"></i>
                            Profile
                        </span>
                    </li>
                    <li onClick={handleLogout}>
                        <span>
                            <i className="fa fa-sign-out"></i>
                            Logout
                        </span>
                    </li>
                </ul>
            </div>

            {/* Main Content */}
            <div className="content">
                {/* ─── Make Payment Tab ───────────────────────────────────────────── */}
<div id="make-payment" className="tab-content active">
  <h2>💳 Make Payment</h2>
  <ChatBot/>

  { !hasPayment ? (
    <>
      {/* ─── HOT-OFFER BOX ───────────────────────────────────────────── */}
      <div className="hot-offer-box">
        <h3>🔥 Hot Offer</h3>
        <p>
          Get <strong>15+ universities</strong> personally recommended for you based on your profile, with budget estimates.
        </p>
        <p>
          Includes a 1-to-1 meeting with our expert team to discuss your profile and next steps.
        </p>
      </div>
      {/* ─────────────────────────────────────────────────────────────── */}

      {/* ─── Promo-Poster Card for Unpaid Users ─────────────────────────────── */}
<div className="dashboard-card payment-card promo-card">
  <div className="promo-header">
    🎉 Exclusive Premium Access
  </div>
  <p className="promo-subtitle">
    Get <strong>15+</strong> hand-picked university recommendations<br/>
    & a 1-on-1 consultation with our expert advisors.
  </p>
  <ul className="promo-features">
    <li><i className="fa fa-check"></i> Tailored university matches</li>
    <li><i className="fa fa-check"></i> Full budget & scholarship overview</li>
    <li><i className="fa fa-check"></i> Personal consultation call</li>
    <li><i className="fa fa-check"></i> CV & SOP review</li>
  </ul>
  <div className="promo-action">
    {/* re-use your existing payment button/component */}
    <PaymentSection user={user} />
  </div>
</div>

    </>
  ) : (
    <div className="dashboard-card payment-card paid-card">
      <h3><i className="fa fa-check-circle"></i> Payment Completed</h3>
      <p>
        Thank you for your payment!  
        Please click below to view your personalized University Recommendations.
      </p>
      <button
        className="btn btn-primary go-to-recs"
        onClick={() => {
          // activate the Recommendations tab programmatically
          document.querySelector('[data-tab="recommendations"]').click();
        }}
      >
        View Recommendations
      </button>
    </div>
  )}
</div>


                {/* Dashboard */}
                {/* <div id="dashboard" className="tab-content">
                    <h2>📋 Academic Questionnaire</h2>
                    <ChatBot/>
                  

                    {selectedQuestionnaire && (
                        <div className="questionnaire-summary-box">
                            <h3>✅ Questionnaire Completed</h3>
                            <p className="questionnaire-summary-subtitle">
                                Thank you for providing your academic preferences. Here's a summary of your information:
                            </p>
                            <div className="questionnaire-details">
                                <div className="detail-item">
                                    <span className="detail-label">
                                        <i className="fa fa-graduation-cap"></i>
                                        Highest Education
                                    </span>
                                    <span className="detail-value">{selectedQuestionnaire.EducationLevel.name}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">
                                        <i className="fa fa-book"></i>
                                        Field of Study
                                    </span>
                                    <span className="detail-value">{selectedQuestionnaire.FieldOfStudy.name}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">
                                        <i className="fa fa-globe"></i>
                                        Country
                                    </span>
                                    <span className="detail-value">{selectedQuestionnaire.Country.name}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">
                                        <i className="fa fa-language"></i>
                                        English Proficiency
                                    </span>
                                    <span className="detail-value">{selectedQuestionnaire.languageTest}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">
                                        <i className="fa fa-dollar-sign"></i>
                                        Estimated Budget
                                    </span>
                                    <span className="detail-value">{selectedQuestionnaire.Fee.amount}</span>
                                </div>
                            </div>
                            <button onClick={handleEditClick} className="edit-questionnaire-button">
                                <i className="fa fa-edit"></i>
                                Update Questionnaire
                            </button>
                        </div>
                    )}
                </div> */}

                {/* Profile */}
                <div id="profile" className="tab-content">
                    <h2>👤 My Profile</h2>
                    <ChatBot/>
                    <div className="profile-summary-box">
                        <h3>Personal Information</h3>
                        <p className="profile-details-subtitle">
                            Manage your personal details and account information
                        </p>
                        <div className="profile-details">
                            <p>
                                <span><i className="fa fa-user"></i> Full Name:</span>
                                <span>{user.name || 'Not provided'}</span>
                            </p>
                            <p>
                                <span><i className="fa fa-id-card"></i> First Name:</span>
                                <span>{user.firstName || 'Not provided'}</span>
                            </p>
                            <p>
                                <span><i className="fa fa-id-card"></i> Last Name:</span>
                                <span>{user.lastName || 'Not provided'}</span>
                            </p>
                            <p>
                                <span><i className="fa fa-envelope"></i> Email:</span>
                                <span>{user.email}</span>
                            </p>
                            <p>
                                <span><i className="fa fa-phone"></i> Contact:</span>
                                <span>{user.contact || 'Not provided'}</span>
                            </p>
                            {/* <p>
                                <span><i className="fa fa-flag"></i> Country:</span>
                                <span>{user.location || 'Not provided'}</span>
                            </p> */}
                            {/* <p>
                                <span><i className="fa fa-city"></i> City:</span>
                                <span>{user.city || 'Not provided'}</span>
                            </p>
                            <p>
                                <span><i className="fa fa-map-marker-alt"></i> State:</span>
                                <span>{user.province || 'Not provided'}</span>
                            </p>
                            <p>
                                <span><i className="fa fa-venus-mars"></i> Gender:</span>
                                <span>{user.gender || 'Not provided'}</span>
                            </p>
                            <p>
                                <span><i className="fa fa-birthday-cake"></i> Birthdate:</span>
                                <span>{user.birthdate ? new Date(user.birthdate).toLocaleDateString() : 'Not provided'}</span>
                            </p> */}
                        </div>
                        <button className="edit-profile-button" onClick={() => setShowEditProfileForm(true)}>
                            <i className="fa fa-edit"></i>
                            Update Profile
                        </button>
                    </div>
                </div>
{/* ── University Recommendations Tab ── */}
<div id="recommendations" className="tab-content">
  <h2>🏫 University Recommendations</h2>

  {/* Premium section */}
  {hasPayment && (
    <div className="premium-section">
      <h3>📘 Premium Recommendation Report</h3>
      <p>Get AI-powered recommendations tailored to your academic profile.</p>
      <PremiumUniversityAdvisor user={user} />
    </div>
  )}

  {/* Normal section */}
  {!hasPayment ? (
    <>
      {/* Filters bar */}
      <div className="recommendations-filters">
        <div className="filter-pills">
          <strong>Field:</strong>
          {Object.keys(fields).map(f => (
            <button
              key={f}
              className={`pill ${fields[f] ? 'active' : ''}`}
              onClick={() => {
                toggleField(f);
                setShowResults(false);
              }}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="filter-inputs">
          {[
            ['Max Tuition', maxTuition, v => setMaxTuition(v)],
            ['Min GPA',     minGPA,     v => setMinGPA(v)],
            ['Min TOEFL',   minTOEFL,   v => setMinTOEFL(v)],
            ['Min IELTS',   minIELTS,   v => setMinIELTS(v)],
            ['Min Duolingo',minDuolingo,v => setMinDuolingo(v)],
          ].map(([label, val, setter]) => {
            const isRequired = ['Max Tuition', 'Min GPA'].includes(label);
            const isTestScore = ['Min TOEFL', 'Min IELTS', 'Min Duolingo'].includes(label);
            const testScoreMissing = !minTOEFL && !minIELTS && !minDuolingo;

            const showError =
              attemptedSearch &&
              (
                (isRequired && val === '') ||
                (isTestScore && testScoreMissing && minTOEFL === val && minIELTS === val && minDuolingo === val) ||
                (label === 'Min GPA' && (+val < 0 || +val > 4))
              );

            return (
              <div className="filter-item" key={label}>
                <label>{label}</label>
                <input
                  type="number"
                  className={showError ? 'invalid-input' : ''}
                  value={val}
                  placeholder={`e.g. ${label.split(' ')[1]}`}
                  onChange={e => {
                    setter(e.target.value);
                    setShowResults(false);
                  }}
                />
                {showError && (
                  <small className="error-text">
                    {label === 'Min GPA' && (+val < 0 || +val > 4)
                      ? 'GPA must be between 0 and 4.0'
                      : `${label} is required`}
                  </small>
                )}
              </div>
            );
          })}
        </div>

        {/* Search Button */}
        <button
          className="search-btn"
          onClick={handleSearchRecs}
          disabled={!(minGPA !== '' && maxTuition !== '' && (minTOEFL || minIELTS || minDuolingo))}
        >
          Search
        </button>
      </div>

      {/* Loading bar */}
      {recLoading && (
        <div className="loading-bar"><div className="loading-bar-progress" /></div>
      )}

      {/* Results */}
      {showResults && !recLoading && (
        filteredRecs.length === 0
          ? <p className="no-results">No matches found.</p>
          : <div className="universities-list">
              {filteredRecs.map(u => (
                <div key={u.id} className="university-card">
                  <h4>{u.name}</h4>
                  <p className="location">{u.city}, {u.state}</p>
                  <p><strong>Tuition:</strong> ${u.annualTuitionUSD}</p>
                  <p><strong>Acceptance:</strong> {u.acceptanceRate}</p>
                  <div className="card-buttons">
                    <button className="budget-btn" onClick={() => openBudget(u)}>Calculate Budget</button>
                    <button className="apply-btn" onClick={() => handleApply(u.id)}>Apply Now</button>
                  </div>
                </div>
              ))}
            </div>
      )}
    </>
  ) : (
    // Premium users: keep normal UI mounted but disabled so it doesn’t steal attention.
    <div className="normal-disabled">
      <div className="disabled-overlay">
        Normal search is disabled for Premium users. Use the Premium report above. 🎯
      </div>
      {/* The markup below mirrors the normal block so CSS can dim it. */}
      <div className="recommendations-filters">
        <div className="filter-pills">
          <strong>Field:</strong>
          {Object.keys(fields).map(f => (
            <button key={f} className="pill">{f}</button>
          ))}
        </div>
        <div className="filter-inputs">
          {['Max Tuition','Min GPA','Min TOEFL','Min IELTS','Min Duolingo'].map(label=>(
            <div className="filter-item" key={label}>
              <label>{label}</label>
              <input type="number" disabled />
            </div>
          ))}
        </div>
        <button className="search-btn" disabled>Search</button>
      </div>
    </div>
  )}

  {/* Budget Modal (unchanged) */}
  {showBudgetModal && budgetUni && (() => {
    const fees = { application:100, sevis:350, visa:160, extras:200 };
    const totalAnnual =
      budgetUni.annualTuitionUSD +
      budgetUni.avgLivingCostUSD +
      fees.application + fees.sevis + fees.visa + fees.extras;

    return (
      <div className="budget-modal-backdrop">
        <div className="budget-modal">
          <button className="modal-close-btn" onClick={() => setShowBudgetModal(false)}>×</button>
          <h3>{budgetUni.name} Cost Estimate</h3>
          <p><strong>Tuition:</strong> ${budgetUni.annualTuitionUSD}</p>
          <p><strong>Living Cost:</strong> ${budgetUni.avgLivingCostUSD}</p>
          <p><strong>Application Fee:</strong> ${fees.application}</p>
          <p><strong>SEVIS Fee:</strong> ${fees.sevis}</p>
          <p><strong>Visa Fee:</strong> ${fees.visa}</p>
          <p><strong>Other Extras:</strong> ${fees.extras}</p>
          <hr/>
          <p><strong>Total Annual Cost:</strong> ${totalAnnual}</p>
          <p><strong>Monthly Estimate:</strong> ${Math.floor(totalAnnual/12)}/mo</p>
        </div>
      </div>
    );
  })()}
</div>

  

                {/* Schedule Appointment */}
                <div id="schedule-appointment" className="tab-content">
                    <h2>📅 Schedule Appointment</h2>
                    <ChatBot/>
                    <div className="dashboard-card">
                        <h3>
                            <i className="fa fa-calendar-plus"></i>
                            Book Your Consultation
                        </h3>
                        <p>
                            Schedule a personalized consultation with our expert advisors to discuss 
                            your academic goals and application strategy.
                        </p>
                        <div className={!hasPayment ? 'blur-content' : ''}>
                            <GoogleCalendar />
                        </div>
                        {!hasPayment && (
                            <div className="note">
                                Complete your payment to unlock appointment scheduling features
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Modals */}
            {showEditProfileForm && (
                <EditProfileForm
                    user={user}
                    onClose={() => setShowEditProfileForm(false)}
                    onUpdate={(updatedProfile) => {
                        setUser(prevUser => ({
                            ...prevUser,
                            ...updatedProfile
                        }));
                        localStorage.setItem('user', JSON.stringify({ ...user, ...updatedProfile }));
                        setShowEditProfileForm(false);
                    }}
                />
            )}
            
            {/* {showQuestionnaire && (
  <Questionnaire
    user={user}
    onSubmit={() => {
      setShowQuestionnaire(false);
      setHasAnsweredQuestionnaire(true);
      checkQuestionnaireStatus();
    }}
    onClose={() => setShowQuestionnaire(false)}
    onUpdate={checkQuestionnaireStatus}
  />
)} */}

             {showEditQuestionnaire && (
                <EditQuestionnaire
                    questionnaireId={selectedQuestionnaire.id}
                    questionnaireData={selectedQuestionnaire}
                    onClose={() => setShowEditQuestionnaire(false)}
                    onUpdate={handleQuestionnaireUpdate}
                />
            )} 
        </div>
    );
};

export default Dashboard;